import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RequestsPage } from '@/components/employee/requests/requests-page';

/**
 * Tab state rides the URL, as it does on the Approvals screen: a chip can be
 * linked to, survives a reload, and moves with the back button.
 *
 * Both fall back rather than throwing — a stale or hand-edited link should
 * land on the first group, not on an error screen.
 */
const requestsSearchSchema = z.object({
  group: z.enum(['admin', 'advances', 'vendor']).optional().catch('admin'),
  type: z
    .enum([
      'LEAVE_APPROVAL',
      'OVERTIME_APPROVAL',
      'QUOTATION_APPROVAL',
      'CONTRACT_APPROVAL',
      'SALARY_APPROVAL',
      'OPERATIONAL_APPROVAL',
      'GENERAL_APPROVAL',
      'TRAVEL_APPROVAL',
      'VENDOR_BILL',
      'REIMBURSEMENT_BILL',
    ])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/(app)/employee/requests/')({
  component: EmployeeRequestsPage,
  validateSearch: requestsSearchSchema,
});

function EmployeeRequestsPage() {
  return <RequestsPage />;
}
